'use client'

import { PriceAlertBanner } from './price-alert-banner'
import { useProductPurchase } from './purchase-context'

export const PriceAlertSelection = () => {
  const purchase = useProductPurchase()
  if (!purchase || purchase.selectedLevel.lowestPrice == null) {
    return null
  }
  const { configuration, selectedModel, selectedLevel } = purchase
  return (
    <PriceAlertBanner
      release={{
        name: configuration,
        modelId: selectedModel.id,
        imageUrl: selectedModel.imageUrl ?? '',
        levels: [{ id: selectedLevel.id, name: selectedLevel.levelName, price: String(selectedLevel.lowestPrice) }],
      }}
    />
  )
}
